import { CheckIcon } from "@heroicons/react/outline";
import { CopyIcon } from "icons/outline";
import React from "react";
import { cn, Tooltip, useCopyToClipboard } from "ui";

type CopyIconButtonProps = {
  text: string;
  className?: string;
  iconClassName?: string;
  disableTooltip?: boolean;
  isInfo?: boolean;
  onClick?: () => void;
};
export default function CopyIconButton({
  text,
  className,
  disableTooltip,
  iconClassName,
  isInfo,
  onClick,
}: CopyIconButtonProps) {
  const { copy, isCopied } = useCopyToClipboard();

  return (
    <Tooltip disabled={disableTooltip}>
      <Tooltip.Trigger
        className={cn("group", className)}
        aria-label="Copy to clipboard"
        onClick={() => {
          if (isCopied) return;
          copy(text);
          onClick?.();
        }}
      >
        {isCopied ? (
          <CheckIcon
            className={cn("h-4 w-4 text-success", iconClassName)}
            aria-hidden="true"
          />
        ) : (
          <CopyIcon
            className={cn(
              "h-4 w-4 stroke-2 ",
              isInfo
                ? "text-info"
                : "text-foundations-subtler group-hover:text-foundations-subtle",
              iconClassName
            )}
          />
        )}
      </Tooltip.Trigger>
      <Tooltip.Popup size="sm">Copy</Tooltip.Popup>
    </Tooltip>
  );
}
